const colors = {
  /* Main colors - Primary colors */
  primaryYellow: '#F8D000',
  primaryDarkGray: '#0E0E15',

  /* Main colors - Accent Colors */
  accentDanger: '#EF4949',
  accentSuccess: '#47C751',
  accentWarning: '#EB9B01',
  accentInfo: '#248FED',

  /* Main colors - Neutral Colors*/
  neutralBlack: '#000000',
  neutralGray1: '#333333',
  neutralGray2: '#A1A1A1',
  neutralGray3: '#D8D8D8',
  neutralGray4: '#EDEDED',
  neutralGray5: '#F1F1F1',
  neutralWhite: '#FFFFFF',

  /* Brand colors */
  brandBootstrap: '#7952B3',
  brandFacebook: '#3B5999',
  brandTwitter: '#1DA1F2',
  brandInstagram: '#E4405F',

  /* Common color: Button - primary */
  buttonPrimaryDefault: '#387EFD',
  buttonPrimaryHover: '#1449B4',
  buttonPrimaryPress: '#1449B4',
  buttonPrimaryDisabled: 'rgba(39, 97, 214, 0.4)',
  buttonPrimaryCancel: '#989898',

  /* Common color: Button - success */
  buttonSuccessDefault: '#339A03',
  buttonSuccessHover: '#267800',
  buttonSuccessPress: '#267800',
  buttonSuccessDisabled: 'rgba(51, 154, 3, 0.4)',
  buttonSuccessCancel: '#989898',

  //Metronic
  buttonDefaultBackground: '#e4e6ef',
  buttonDefaultBackgroundHover: '#b5b5c3',
  buttonDefaultText: '#3f4254',

  buttonPrimaryBackground: '#009ef7',
  buttonPrimaryBackgroundHover: '#0095e8',
  buttonPrimaryText: '#fff',

  buttonWhiteBackground: '#fff',
  buttonWhiteBackgroundHover: '#f5f8fa',
  buttonWhiteText: '#7e8299',

  buttonDarkBackground: '#181c32',
  buttonDarkBackgroundHover: '#131628',
  buttonDarkText: '#fff',

  buttonDangerBackground: '#f1416c',
  buttonDangerBackgroundHover: '#d9214e',
  buttonDangerText: '#fff',

  buttonWarningBackground: '#ffc700',
  buttonWarningBackgroundHover: '#f1bc00',
  buttonWarningText: '#fff',

  buttonInfoBackground: '#7239ea',
  buttonInfoBackgroundHover: '#5014d0',
  buttonInfoText: '#fff',

  buttonSuccessBackground: '#50cd89',
  buttonSuccessBackgroundHover: '#47be7d',
  buttonSuccessText: '#fff',

  // Primary
  primary: '#009ef7',
  primaryActive: '#0095e8',
  primaryLight: '#f1faff',
  primaryInverse: '#ffffff',

  // // Success
  success: '#50cd89',
  successActive: '#47be7d',
  successLight: '#e8fff3',
  successInverse: '#ffffff',

  // // Info
  info: '#7239ea',
  infoActive: '#5014d0',
  infoLight: '#f8f5ff',
  infoInverse: '#ffffff',

  // Danger
  danger: '#d9330b',
  dangerActive: '#d9214e',
  dangerLight: '#fff5f8',
  dangerInverse: '#ffffff',

  // // Warning
  warning: '#ffc700',
  warningActive: '#f1bc00',
  warningLight: '#fff8dd',
  warningInverse: '#ffffff',

  ///Other
  green: '#23b7e5',

  primaryColor: '#0072FF',
  secondaryColor: '#0E0E15',
  tertiaryColor: '#0E0E15',

  textBoldColor: '#333',
  backgroundColor: '#FFFFFF',
  shadowColor: '#7D14FD',
  notificationSuccess: '#50cd89',
  notificationError: '#f1416c',
  buttonGradient: `linear-gradient(to right, #00C6FF 0%, #0072FF 51%, #00C6FF 100%)`,
  buttonGradientHover: `linear-gradient(to right, #00C6FF 0%, #0072FF 51%, #00C6FF 100%)`,
  buttonActive: '#0E0E15',
  buttonDisable: '#B9B5C2',

  // theme layout
  layoutContentBackground: '#F7F9FB',
  cardBackground: '#ffffff',
  textColor: '#071437',
  textColorGray: '#666',
  borderTable: '#f0f0f0',
  buttonPrimary: '#0095e8',
  inputBackgoundColor: '#ffffff',
  boxShadowHeader: `rgba(33, 35, 38, 0.1) 0px 10px 10px -10px`,
  modalBackground: '#ffffff',
  borderCard: '#f1f1f2',
  boxShadowCard: `rgba(0, 0, 0, 0.03)`,
  backgroundCard: '#ffffff',
  backgroundTableItem: '#f5f5f5',
  other: {
    text1: '#333333',
    text2: '#666666',
    background2: '#f5f5f5',
    grayDark: '#999999',
    red1: '#ff4d4f',
    red2: '#ff7875',
  }
};

export default colors;
